import { Enums } from '@bode-canada/core';
import { QueryParams } from '@/constants/QueryParams';

const { BuildingClassEnum, PropertyTypeEnum } = Enums;

const BUILDING_CLASSES_BY_FILTER_OPTION = {
  [BuildingClassEnum.DETACHED]: [BuildingClassEnum.DETACHED],
  [PropertyTypeEnum.ATTACHED]: [BuildingClassEnum.ROW_TOWNHOUSE, BuildingClassEnum.SEMI_DETACHED],
  [BuildingClassEnum.APARTMENT]: [BuildingClassEnum.APARTMENT],
  [BuildingClassEnum.VACANT_LAND]: [BuildingClassEnum.VACANT_LAND],
};

const FILTER_OPTION_BY_BUILDING_CLASS = {
  [BuildingClassEnum.DETACHED]: BuildingClassEnum.DETACHED,
  [BuildingClassEnum.SEMI_DETACHED]: PropertyTypeEnum.ATTACHED,
  [BuildingClassEnum.ROW_TOWNHOUSE]: PropertyTypeEnum.ATTACHED,
  [BuildingClassEnum.APARTMENT]: BuildingClassEnum.APARTMENT,
  [BuildingClassEnum.VACANT_LAND]: BuildingClassEnum.VACANT_LAND,
};

export default class BuildingClassMapper {
  static mapFilterToQuery(filterOptions) {
    return {
      [QueryParams.BuildingClass]: this.#getBuildingClassesFromFilter(filterOptions),
    };
  }

  static mapQueryToFilter(buildingClasses) {
    return {
      [QueryParams.BuildingClass]: this.#getFilterFromBuildingClasses(buildingClasses),
    };
  }

  static #getBuildingClassesFromFilter(filterOptions) {
    return Object.entries(BUILDING_CLASSES_BY_FILTER_OPTION)
      .reduce((accum, [buildingClass, classes]) => (
        filterOptions.includes(buildingClass)
          ? [...accum, ...classes]
          : accum
      ), []);
  }

  static #getFilterFromBuildingClasses(buildingClasses) {
    const filterOptions = Object.entries(FILTER_OPTION_BY_BUILDING_CLASS)
      .reduce((accum, [buildingClass, filterOption]) => {
        if (buildingClasses.includes(buildingClass)) {
          accum.add(filterOption);
        }

        return accum;
      }, new Set());

    return [...filterOptions];
  }
}
